module.exports = __webpack_public_path__ + "static/media/proj15_img6.74f24703.jpg";